<template lang="pug">
app-modal(
  :titulo="tituloModal"
  :width="width",
  @closeModal="$emit('closeModal')"
)
  template(slot="body")
    .padding
      .align-image
        img.senha(
          src="~@/assets/images/assinatura.png",
          alt="sicarf",
          name="senha"
        )
      p
        span(v-if="isBA")
          | Para realizar a assinatura do extrato de sentença é necessário informar a senha do seu certificado digital. Ao finalizar, todos os extratos de sentença selecionados serão assinados.
        span(v-else)
          | Para realizar a assinatura dos {{isErrataTitulo ? 'adendos/retificações' : 'títulos'}} é necessário informar a senha do seu
          | certificado digital. Ao finalizar, todos {{isErrataTitulo ? '' : 'os títulos' }} selecionados serão assinados.
      app-label.magin(label="Senha:", :required="true")
      el-input.input(type="password", v-model="senha")
  template(slot="footer")
    .flex
      el-button.margin-bottom(
        :disabled="senha.length > 3 ? false : true",
        @click="finalizaAssinatura()"
      ) Finalizar
</template>

<script>
import { mapActions } from 'vuex'
import AppModal from '@/components/AppModal'
import AppLabel from '@/components/AppLabel'
import AppNotificacao from '@/components/mixins/AppNotificacao'
import statusProcesso from '@/utils/status'
import { HTTP_STATUS } from '@/utils/api'
export default {

  components: {
    AppModal,
    AppLabel
  },

  mixins: [
    AppNotificacao
  ],

  data () {
    return {
      senha: '',
      isMaranhao: process.env.ESTADO === 'ma',
      isErrataTitulo: null,
      isBA: process.env.ESTADO === 'ba'
    }
  },

  async created () {
    this.isErrataTitulo = await this.isAssinaturaRetificacaoTitulo()
  },

  computed: {
    tituloModal () {
      return this.isBA ? this.titulo : `Assinar ${this.isErrataTitulo ? 'Errata de' : ''} Título`
    }
  },

  props: {
    width: {
      type: Number,
      default: 600
    },
    idsProcessos: {
      type: Array,
      required: true
    },
    tipo: {
      type: String,
      required: false
    },
    titulo: {
      type: String,
      required: false,
      default: 'Assinar Título'
    },
    isExtratoSentenca: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    ...mapActions({
      finalizarCcr: 'processo/finalizaAssinaturaOficio',
      tramitarComAcao: 'processo/tramitarComAcao',
      finalizar: 'processo/finalizaAssinatura',
      atualizarProcessoAssinatura: 'processo/atualizarProcessoAssinatura',
      getProcessoById: 'processo/getProcessoById',
      finalizaAssinaturaRetificacaoTitulo: 'processo/finalizaAssinaturaRetificacaoTitulo',
      finalizarExtratoSentenca: 'processo/finalizaAssinaturaExtratoSentenca'
    }),
    async finalizaAssinatura () {
      debugger
      try {
        const isErrataTitulo = await this.isAssinaturaRetificacaoTitulo()
        let promises
        await this.atualizarProcessoAssinatura(this.idsProcessos)
        if (this.tipo === 'CANCELAMENTO_CLAUSULA_RESOLUTIVA' || this.tipo === 'Cancelamento cláusula resolutiva') {
          promises = this.idsProcessos.map(idProcesso => {
            return this.finalizarCcr({ idProcesso, senha: this.senha })
              .then(result => ({ status: 'fulfilled', idProcesso, result }))
              .catch(error => {
                return error.status === HTTP_STATUS.UNPROCESSBLE_ENTITY
                  ? { status: 'validation', idProcesso, message: error.message }
                  : { status: 'rejected', idProcesso, message: error }
              })
          })
        } else if (isErrataTitulo) {
          promises = this.idsProcessos.map(idProcesso => {
            return this.finalizaAssinaturaRetificacaoTitulo({ idProcesso, senha: this.senha, statusProcesso: statusProcesso.AGUARDANDO_ASSINATURA })
              .then(result => ({ status: 'fulfilled', idProcesso, result }))
              .catch(error => {
                return error.status === HTTP_STATUS.UNPROCESSBLE_ENTITY ? { status: 'validation', idProcesso, message: error.message } : { status: 'rejected', idProcesso, message: error }
              })
          })
        } else if (this.isExtratoSentenca) {
          await this.finalizarExtratoSentenca({ idProcessos: this.idsProcessos, senha: this.senha, statusProcesso: statusProcesso.AGUARDANDO_ASSINATURA })
          this.showNotificacao(this.$messages.TIPO_SUCCESS, this.$messages.TITULO_SUCCESS,
            this.$messages.TITULOS_CERTIDOES_ENVIADOS)
          this.$emit('closeModal')
          this.$emit('closeModaLimparCamposAssinatura')
          return
        } else {
          promises = this.idsProcessos.map(idProcesso => {
            return this.finalizar({ idProcesso, senha: this.senha, statusProcesso: statusProcesso.AGUARDANDO_ASSINATURA })
              .then(result => ({ status: 'fulfilled', idProcesso, result }))
              .catch(error => {
                return error.status === HTTP_STATUS.UNPROCESSBLE_ENTITY ? { status: 'validation', idProcesso, message: error.message } : { status: 'rejected', idProcesso, message: error }
              })
          })
        }
        Promise.allSettled(promises).then(results => {
          this.$emit('closeModal')
          const errors = results.filter(result => result.value.status === 'rejected')
          const errorsValidation = results.filter(result => result.value.status === 'validation')
          if (errors.length > 0) {
            const errorMessages = errors.map(error => error.value.message).toString().replace(/,/g, ',\n')
            this.showNotificacao(this.$messages.TIPO_WARNING, this.$messages.TITULO_WARNING,
              `Os processos com número: ${errorMessages} falharam. Tente novamente!`)
          } else if (errorsValidation.length > 0) {
            this.showNotificacao(this.$messages.TIPO_WARNING, this.$messages.TITULO_WARNING,
            errorsValidation[0]?.value?.message)
          } else {
            this.showNotificacao(this.$messages.TIPO_SUCCESS, this.$messages.TITULO_SUCCESS,
              isErrataTitulo ? this.$messages.ERRATA_ENVIADA_ASSINATURA : this.$messages.TITULOS_CERTIDOES_ENVIADOS)
          }
        })
        this.$emit('closeModal')
        this.$emit('closeModaLimparCamposAssinatura')
      } catch (e) {
        this.$emit('closeModal')
      }
    },
    async tramitaComAcao () {
      await this.tramitarComAcao({
        processoId: this.idsProcessos[0],
        acao: 'ASSINADO.PRESIDENTE.PRESIDENCIA.AUTOCOMPLETE'
      })
      this.goToListagem()
    },

    async getStatusProcessos () {
      const promises = this.idsProcessos.map(id => this.getProcessoById(id))
      const results = await Promise.allSettled(promises)
      const status = []
      for (const result of results) {
        if (result.status === 'fulfilled') {
          status.push(result.value.status)
        }
      }
      return status
    },

    async isAssinaturaRetificacaoTitulo () {
      if (!this.isMaranhao) {
        return false
      }
      const status = await this.getStatusProcessos()
      return status.every(s => s === statusProcesso.AGUARDANDO_ASSINATURA_ERRATA_TITULO)
    }
  }
}

</script>

<style scoped lang="scss">
.padding {
  padding: 10px;
  color: #424242;
}

.magin {
  margin-top: 40px;
}

.senha {
  width: auto;
  height: 200px;
}

.align-image {
  display: flex;
  justify-content: center;
}

.flex {
  display: flex;
  justify-content: flex-end;
}
</style>



// WEBPACK FOOTER //
// src/screens/analise/components/AppModalAssinarTitulo.vue